import { Chessboard } from "react-chessboard"
import { useGameMoves } from "@/hooks/useGameMoves"
import clsx from "clsx"

const SolutionBoard = () => {
  const {
    game,
    onSquareClick,
    isDraggablePiece,
    onPieceDragBegin,
    onPieceDrop,
    optionSquares,
    isShaking,
  } = useGameMoves()

  return (
    <div
      className={clsx({
        "animate-shake": isShaking,
      })}
    >
      <Chessboard
        position={game.fen()}
        areArrowsAllowed={false}
        autoPromoteToQueen={false}
        onPromotionCheck={() => false}
        customDarkSquareStyle={{
          backgroundColor: "#c56c1a",
        }}
        customLightSquareStyle={{
          backgroundColor: "#ffd17f",
        }}
        onSquareClick={onSquareClick}
        onPieceDragBegin={(_piece, sourceSquare) =>
          onPieceDragBegin(sourceSquare)
        }
        isDraggablePiece={({ piece }) => isDraggablePiece(piece)}
        onPieceDrop={(sourceSquare, targetSquare) =>
          onPieceDrop(sourceSquare, targetSquare)
        }
        dropOffBoardAction="trash"
        customSquareStyles={optionSquares}
      />
    </div>
  )
}

export default SolutionBoard
